import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';

const useIsMobile = () => {
    const theme = useTheme<Theme>();
    return useMediaQuery<Theme>(theme.breakpoints.down('sm'));
};

export default useIsMobile;
